module.exports = __webpack_public_path__ + "static/media/brochure.11c8cc2b.png";